import type { RootState } from 'store'
import type { Module } from 'vuex'
import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'
import { state } from './state'
import type { DivisionState } from './types'

export const division: Module<DivisionState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
